import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');

let ModelParamsDiv = styled.div`
    padding: 0.5rem;
    margin: 0.5rem;
    border: solid thin grey;
    h1.model-use-case-heading {
        font-size: 1.6rem;
    }
    font-size: 1.4rem;
    display: block;
    .param-option {
        width: 16rem;
        label {
            width: auto;
        }
    }
    .param-input {
        width: 20rem;
        margin-top: 0.3rem;
        label {
            font-weight: normal;
        }
    }
`;

let RadioDiv = styled.div`
    display: block;
    align-items: flex-end;

    .param-option {
        > label {
            text-align: left;
            font-weight: bold;
        }

        .param-option-radio {
            cursor: pointer;

            img {
                height: 1.2em;
                margin-right: 1rem;
                vertical-align: text-bottom;
            }

            > label {
                display: inline-block !important;
                font-weight: normal;
                cursor: pointer;
            }

            &:hover, &:focus {
                opacity: 0.9;
            }
        }

        &.disabled {
            opacity: 0.4;
            pointer-events: none;
        } 

        .match-layout-options {
            display: block;

            .dual-layout {
                margin-right: 1rem;

                .icon-blocker {
                    position: absolute;
                    top: 50%;
                    background-color: inherit;
                    height: 50%;
                    width: 100%;
                }
            }

            .quad-layout {
                .button-w-bgcolor(#dddddd, 5%);
            }
        }  
    }

`;

class AIModelParamsEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modelParameters: {...props.modelParameters },
        }
    }
    
    handleModelOptionRadio=(key,value)=>{
        let modelParameters = this.state.modelParameters || {};
        
        let defaultModelParams = Globals.ai.useCaseModelParams[modelParameters.useCase];

        switch(key) {
            case 'temperature':
                if (value) {
                    delete modelParameters.temperature; // uncheck temperature 
                }
                else {
                    delete modelParameters.top_p;
                    if (typeof modelParameters.temperature !== 'number') {
                        modelParameters.temperature = (typeof defaultModelParams.temperature !== 'undefined') ? defaultModelParams.temperature : 1.0;
                    }
                }
                break;
            case 'top_p':
                if (value) {
                    delete modelParameters.top_p; // uncheck top_p
                }
                else {
                    delete modelParameters.temperature;
                    if (typeof modelParameters.top_p !== 'number') {
                        modelParameters.top_p = (typeof defaultModelParams.top_p !== 'undefined') ? defaultModelParams.top_p : 0.999;
                    }
                }
                break;
        }
        this.props.onChange(modelParameters);
    }
    
    handleModelOptionInput=(key,evt)=>{
        let modelParameters = this.state.modelParameters || {};
        modelParameters[key] = Number(evt.target.value);
        this.props.onChange(modelParameters);
    }
    
    render() {
        let label_id = "model-params-label-" + this.state.modelParameters.useCase;
        let temp_cb_id = "temp-used-" + this.state.modelParameters.useCase;
        let top_p_cb_id = "top-p-used-" + this.state.modelParameters.useCase; 
        let temp_inp_id = "temperature-input-" + this.state.modelParameters.useCase;
        let top_p_inp_id = "top-p-input-" + this.state.modelParameters.useCase;
        
        let modelParameters = this.state.modelParameters || {};
        let {temperature, top_p} = modelParameters;
        let temperature_used = (typeof temperature !== 'undefined');
        let top_p_used = (typeof top_p !== 'undefined');
        let useCaseDisplayName = Strings['en'].ai.useCaseDisplayNames[this.state.modelParameters.useCase];
        
        return (
            <ModelParamsDiv className="model-parameters">
                <h1 className="model-use-case-heading">{`AI Model Parameters for ${useCaseDisplayName}`}</h1>
                <RadioDiv className="labeled-toggle">
                    <div className="param-option">
                        <div role="radiogroup" aria-labelledby={label_id}>
                            <div id={temp_cb_id} className="param-option-radio"
                                role="radio" aria-checked={temperature_used} tabIndex={temperature_used ? 0 : 0}
                                onClick={this.handleModelOptionRadio.bind(this,'temperature',temperature_used)}>
                                <i className={temperature_used ? "fa fa-check-circle" : "fa fa-circle-o"}/>
                                <label htmlFor={temp_cb_id}>Use Temperature</label>
                            </div>
                            <div id={top_p_cb_id} className="param-option-radio"
                                role="radio" aria-checked={top_p_used} tabIndex={top_p_used ? 0 : 1}
                                onClick={this.handleModelOptionRadio.bind(this,'top_p',top_p_used)}>
                                <i className={top_p_used ? "fa fa-check-circle" : "fa fa-circle-o"}/>
                                <label htmlFor={top_p_cb_id}>Use Top P</label>
                            </div>
                        </div>
                    </div>
                </RadioDiv>
                <div className="param-input">
                    {temperature_used ? 
                    <div className="param-row">
                        <label htmlFor={temp_inp_id}>Temperature:</label>
                        <input id={temp_inp_id} type="number" disabled={!temperature_used} min={0} max={1} step={0.1} value={temperature} 
                            onChange={this.handleModelOptionInput.bind(this,'temperature')}
                        />
                    </div>
                    : null }
                    { top_p_used ? 
                    <div className="param-row">
                        <label htmlFor={top_p_inp_id}>Top P:</label>
                        <input id={top_p_inp_id} type="number" disabled={!top_p_used} min={0} max={1} step={0.1} value={top_p} 
                            onChange={this.handleModelOptionInput.bind(this,'top_p')}
                        />
                    </div>
                    : null }
                </div>
            </ModelParamsDiv>
        );
    }
}

AIModelParamsEditor.propTypes = {
    modelParameters: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default AIModelParamsEditor;